import styled from "@emotion/styled";

import greenBackImage from "../../images/top-background.svg";
import grayBackImage from "../../images/top-background-gray.svg";
import greenBackImageDesktop from "../../images/bottom-background-desktop.svg";
import grayBackImageDesktop from "../../images/bottom-background-gray-desktop.svg";
import {
  BREAKPOINTS,
  DIMENSIONS,
  MOBILE_MAX_WIDTH,
  getBackgroundColor,
  media
} from "../constants";

export const Div = styled.div`
  width: ${(props) => props.width || "100%"};
  height: ${(props) => props.height || "100%"};
  gap: ${(props) => props.gap || "20px"};
  display: ${(props) => props.display || "flex"};
  justify-content: ${(props) =>
    props.justifySpace
      ? "space-between"
      : props.justifySpaceEvenly
      ? "space-evenly"
      : props.justifyStart
      ? "flex-start"
      : props.justifyEnd
      ? "flex-end"
      : "center"};
  align-items: ${(props) =>
    props.alignStart
      ? "flex-start"
      : props.alignEnd
      ? "flex-end"
      : "center"};
  flex-direction: ${(props) => (props.row ? "row" : "column")};
  flex-wrap: ${(props) => props.wrap || "" };
  background-color: ${getBackgroundColor};
  padding: ${(props) => props.padding || "0"};
  margin: ${(props) => props.margin || "0"};
  border-radius: ${(props) => props.borderRadius || "0"};
  font-family: ${({ theme }) => theme.typography.fontFamily};
  border: ${({ theme, grayBorder }) =>
    grayBorder ? `1px solid ${theme.custom.grayBorder}` : "none"};
  font-size: ${(props) => props.fontSize};
  font-weight: ${(props) => props.fontWeight};
  cursor: ${(props) => props.cursor || ""};
  position: ${(props) => props.position};
  z-index: ${(props) => props.zIndex};
  

  ${media.max(BREAKPOINTS.mobileMax)} {
    width: ${(props) => props.mobileWidth || "100%"};
    justify-content: ${(props) =>
      props.mobileJustifySpace
        ? "space-between"
        : props.mobileJustifySpaceEvenly
        ? "space-evenly"
        : props.mobileJustifyStart
        ? "flex-start"
        : props.mobileJustifyEnd
        ? "flex-end"
        : "center"};
    align-items: ${(props) =>
      props.mobileAlignStart
        ? "flex-start"
        : props.mobileAlignEnd
        ? "flex-end"
        : props.mobileAlignStretch
        ? "stretch"
        : "center"};
  }
`;

export const ShortString = styled.div`
  label: short-string;
  display: flex;
  width: 100%;
  flex-direction: row;
  gap: 5px;
  justify-content: ${(props) => props.justify || "flex-start"};
  align-items: center;
  padding: 0;
`;

export const BackScreenDiv = styled(Div)`
  label: back-screen-div;
  position: fixed;
  height: 100%;
  background-image: ${(props) =>
    props.greenImage
      ? `url(${greenBackImage})`
      : props.grayImage
      ? `url(${grayBackImage})`
      : "none"};
  background-repeat: no-repeat;
  background-position: center top;
  background-size: contain;
  z-index: 0;

  ${media.between(480, BREAKPOINTS.tabletMin)} {
    top: -150px;
  }

  ${media.min(BREAKPOINTS.tabletMin)} {
    width: calc(100% - 300px);
    background-image: ${(props) =>
      props.greenImage
        ? `url(${greenBackImageDesktop})`
        : props.grayImage
        ? `url(${grayBackImageDesktop})`
        : "none"};
    background-position: center bottom;
    align-self: flex-end;
    bottom: 0;
  }
`;

export const ScrollContainer = styled.div`
  label: scroll-container;
  display: flex;
  flex-direction: column;
  overflow-y: auto;
  width: 100%;
  -webkit-overflow-scrolling: touch;
  height: calc(var(--vh, 1vh) * 100);
  position: relative;
  align-items: ${(props) => props.alignItems || "flex-start"};
  justify-content: ${(props) => props.justifyContent || "flex-start"};
  background-color: ${getBackgroundColor};

  ${media.min(BREAKPOINTS.narrowDesktopMin)} {
    width: ${(props) => props.width || `calc(100% - ${DIMENSIONS.sidebarWidth}px)`};
    align-self: ${(props) => props.alignSelf || "flex-end"};
  }

  ${media.between(BREAKPOINTS.narrowDesktopMin, BREAKPOINTS.narrowDesktopMax)} {
    width: 90%;
    align-self: center;
    height: auto;
    min-height: auto;
    padding-top: 100px;
  }
`;

export const ScreenDiv = styled(Div)`
  label: screen-div;
  width: ${(props) =>
    props.fullWidth ? "100%" : props.width || "clamp(300px, 100%, 1000px)"};
  box-sizing: ${(props) => (props.fullWidth ? "border-box" : "content-box")};
  height: ${(props) => props.height || "auto"};
  align-self: ${(props) => (props.noAccount ? "" : "flex-start")};
  display: flex;
  flex-direction: column;
  justify-content: ${(props) => props.justifyContent || "flex-start"};
  align-items: ${(props) =>
    props.fullWidth ? "stretch" : props.alignItems || "center"};
  z-index: 90;
  gap: ${(props) => props.gap || "20px"};
  padding: ${(props) => props.padding || "20px"};
  margin-top: ${(props) => props.marginTop || "0"};

  ${media.max(MOBILE_MAX_WIDTH)} {
    justify-content: ${(props) => props.justifyContentMobile || "flex-start"};
  }

  ${media.between(481, BREAKPOINTS.mobileMax)} {
    width: ${(props) => props.tabletWidth || "100%"};
    height: 100%;
    justify-content: ${(props) => props.justifyContentTablet || "flex-start"};
    padding: ${(props) => props.paddingTablet || "40px"};
    z-index: 90;
  }

  ${media.min(BREAKPOINTS.tabletMin)} {
    min-height: 100%;
    height: auto;
    width: ${(props) =>
      props.fullWidth
        ? `calc(100% - ${DIMENSIONS.sidebarWidth}px)`
        : props.noAccount
        ? "clamp(300px, 100%, 1000px)"
        : `clamp(300px, calc(100% - ${DIMENSIONS.sidebarWidth}px), 1000px)`};
    max-width: ${(props) => (props.fullWidth ? "none" : undefined)};
    margin-left: ${(props) =>
      props.paddingLeft || props.noAccount ? "0" : `${DIMENSIONS.sidebarWidth}px`};
    z-index: 84;
  }
`;

export const ContentDiv = styled(Div)`
  label: content-div;
  padding: ${(props) => props.padding || (props.paddingBack ? "20px" : "0")};
  margin-top: ${(props) => props.marginTop || "0"};

  ${media.max(MOBILE_MAX_WIDTH)} {
    padding: ${(props) => props.paddingMobile || (props.paddingBack ? "20px" : "0")};
    height: ${(props) => props.heightMobile || "100%"};
    justify-content: ${(props) => props.justifyContentMobile || "flex-start"};
  }

  ${media.min(821)} {
    height: ${(props) => props.heightDesktop || "auto"};
    justify-content: ${(props) => props.justifyContentDesktop || "flex-start"};
  }
`;

export const HeaderDiv = styled(Div)`
  label: header-div;
  height: ${(props) => props.height || "40px"};
  padding: ${(props) => props.padding || "0"};
  flex-direction: row;
  justify-content: space-between;
  flex-shrink: 0;
  position: ${(props) => props.position || ""};
  background-color: ${(props) => props.background || "" };

  ${media.min(BREAKPOINTS.desktopMin)} {
    height: ${(props) => props.deskHeight || "40px"};
  }

  @media (max-width: 821px) {
    justify-content: space-between;
  }
`;

export const HeaderDivMain = styled(Div)`
  label: header-div-main;
  width: 100%;
  height: 60px;
  position: fixed;
  top: 0;
  background-color: ${({ theme, green, gray }) =>
    green
      ? theme.palette.primary.main
      : gray
      ? theme.palette.background.backGray
      : "transparent"};
  flex-direction: row;
  padding: 25px 20px 20px 20px;
  justify-content: space-between;
  box-shadow: ${({ scrolled }) =>
    scrolled ? "0 2px 6px rgba(0, 0, 0, 0.1)" : "none"};
  transition: box-shadow 0.3s ease;

  ${media.min(BREAKPOINTS.tabletMin)} {
    justify-content: space-between;
    background-color: ${({ theme }) => theme.palette.background.lightGray};
    z-index: 85;
    height: 70px;
    padding: 20px 30px;
  }

  ${media.max(BREAKPOINTS.mobileMax)} {
    z-index: 97;
  }
`;

export const FooterDiv = styled(Div)`
  label: footer-div;
  height: ${(props) => props.height || "60px"};
  flex-shrink: 0;
`;

export const FooterDivMain = styled(Div)`
  label: footer-div-main;
  height: auto;
  background-color: ${({ theme }) => theme.palette.background.lightGray};
  position: fixed;
  bottom: 0;
  top: auto;
  padding-top: 5px;
  padding-left: 15px;
  padding-right: 15px;
  padding-bottom: ${({ pwa }) => (pwa ? "25px" : "5px")};
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.1);

  ${media.min(BREAKPOINTS.tabletMin)} {
    background-color: ${({ theme }) => theme.palette.primary.main};
    width: ${DIMENSIONS.sidebarWidth}px;
    height: 100vh;
    top: 0;
    bottom: 0;
    left: 0;
    flex-direction: column;
    justify-content: flex-start;
    align-items: center;
    gap: 10px;
    padding: 100px 0 30px 0;
    z-index: 80;
  }

  ${media.max(BREAKPOINTS.mobileMax)} {
    z-index: 97;
  }
`;

export const ShadowDiv = styled(Div)`
  label: shadow-div;
  justify-content: flex-start;
  padding: 20px;
  gap: ${(props) => props.gap || "20px"};
  border-radius: 20px;
  box-shadow: 0px 2px 10px rgba(0, 0, 0, 0.1);
  height: auto;
  background-color: ${({ theme }) => theme.custom.white};
  width: ${(props) => props.width || "auto"};

  ${media.min(BREAKPOINTS.tabletMin)} {
    align-items: flex-start;
  }
`;

export const Divider = styled.span`
  label: divider;
  flex: 1;
  height: 2px;
  background-color: ${({ theme }) => theme.custom.grayInputs};
`;

export const ErrorMessage = styled(Div)`
  color: ${({ theme }) => theme.palette.error.main};
`;


